import { lazy } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import type { AppletDefinition } from '../../applets';
import {
  CartographerLayout,
  CartographerLayoutAccessDenied,
  CartographerLayoutLoading,
} from './Layout';

const CartographerRoute = lazy(() => import('./CartographerRoute'));

const applet = {
  id: 'cartographer',
  path: '/cartographer',
  paths: ['/cartographer'],
  label: 'Cartographer',
  description: 'Universal motion retargeting',
  dashboard: {
    imageSrc:
      'https://resources.getcartwheel.com/share/demo-videos/cartographer-thumb.jpg',
    imageAlt: '',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/app_launcher_cartographer.webm',
    title: 'Cartographer',
    description: 'Universal motion retargeting',
    order: 40,
  },
  policy: {
    requiresAdmin: false,
    requiresApiKey: 'soft',
    requiresLoggedIn: false,
  } satisfies Policy,
  component: CartographerRoute,
  layout: CartographerLayout,
  loading: CartographerLayoutLoading,
  accessDenied: CartographerLayoutAccessDenied,
} satisfies AppletDefinition;

export default applet;
